/// <amd-module name="SuiteCommerce.LookBook.LookBook"/>
define("SuiteCommerce.LookBook.LookBook", ["require", "exports", "SuiteCommerce.LookBook.LookBook.Router"], function (require, exports, LookBook_Router_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            return new LookBook_Router_1.LookBookRouter({
                application: container,
                routes: {},
            });
        },
    };
});
